/* eslint-disable */
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import { alpha, useTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { apiUrl, postRequest } from '../utils/services';
import { AuthContext } from '../context/AuthContext';
import Logo from '../components/logo';
import Iconify from '../components/iconify';
import { bgGradient } from '../theme/css';

export default function ResetPasswordPage() {

    const theme = useTheme();
    const navigate = useNavigate();
   
    const { token } = useParams();

    const [buttonLoad, setButtonLoad] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isValidate, setIsValidate] = useState(false);

    // const { loginUser, forgotPasswordInfo, loginError, isLoginLoading, updateForgotPasswordInfo } = useContext(AuthContext);
    const { forgotPasswordInfo, setToats, updateForgotPasswordInfo } = useContext(AuthContext);

    useEffect(() => {
        const tokenCheck = async () => {
            const response = await postRequest(`${apiUrl}/users/reset-password-token`, JSON.stringify({ token }));
            console.log(token);
            if (response.error) {
                console.error('Error:', response.error);
                setIsValidate(false)
                setToats({
                    message: response?.message?.error ?? response?.message,
                    open: true,
                    type: 'error'
                })
                // return;
            } else {
                setIsValidate(true)
                // navigate('/chat/login');
            }
            setIsLoading(false)
        }
        tokenCheck();
    }, [token, setToats])
    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setButtonLoad(true);

        if (newPassword === '') {
            setToats({
                message: 'New Password field is required!',
                open: true,
                type: 'error'
            })
            setButtonLoad(false);
            return;
        }
        if (newPassword !== confirmPassword) {
            setToats({
                message: 'New Password and Confirm Password should be match!',
                open: true,
                type: 'error'
            })
            setButtonLoad(false);

            return;
        }
        const response = await postRequest(`${apiUrl}/users/reset-password`, JSON.stringify({token, newPassword }));

        if (response.error) {
            console.error('Error:', response.error);
            setToats({
                message: response?.message?.error ?? response?.message,
                open: true,
                type: 'error'
            })
            // return;
        } else {
            setToats({
                message: response?.message,
                open: true,
                type: 'success'
            })
            navigate('/chat/login');
        }

        setButtonLoad(false);

    }

    const renderForm = (
        <>
            <form action="" onSubmit={handleForgotPassword}>
                <Stack spacing={3}>
                    <TextField
                        name="newPassword"
                        label="New Password"
                        onChange={((e) => setNewPassword(e.target.value))}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        name="confirmPassword"
                        label="Confirm Password"
                        onChange={((e) => setConfirmPassword(e.target.value))}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Stack>

                <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 3 }}>
                    <Link variant="subtitle2" href="/chat/login" underline="hover">
                        Login?
                    </Link>
                </Stack>

                <LoadingButton
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="inherit"
                    onClick={handleForgotPassword}
                    loading={buttonLoad}
                >
                    Update
                </LoadingButton>
            </form>
        </>
    );

    return (
        <>
            <Box
                sx={{
                    ...bgGradient({
                        color: alpha(theme.palette.background.default, 0.9),
                        imgUrl: '/assets/background/overlay_4.jpg',
                    }),
                    height: 1,
                }}
            >
                <Logo
                    sx={{
                        position: 'fixed',
                        top: { xs: 16, md: 24 },
                        left: { xs: 16, md: 24 },
                    }}
                />

                <Stack alignItems="center" justifyContent="center" sx={{ height: 1 }}>
                    {isLoading ? ( // Render loader if isLoading is true
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                            <CircularProgress />
                        </div>
                    ) :
                        <Card
                            sx={{
                                p: 5,
                                width: 1,
                                maxWidth: 420,
                            }}
                        >
                            <Typography variant="h4">Reset Password</Typography>

                            <Typography variant="body2" sx={{ mt: 2, mb: 5 }}>
                                Don’t have an account?
                                <Link href="/chat/register" variant="subtitle2" sx={{ ml: 0.5 }}>
                                    Get started
                                </Link>
                            </Typography>
                            
                            {isValidate?renderForm:<Alert variant="filled" severity="error">
                                This link is expired
                            </Alert>}
                        </Card>
                    }
                </Stack>
            </Box>
        </>
    )
}

